/**
 * @generated SignedSource<<725a8848cdd8f743c804f26a8ee65282>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShippingDetailsQuotesTableRow_viewer$data = {
  readonly showShippingDiscounts: boolean | null;
  readonly " $fragmentType": "ShippingDetailsQuotesTableRow_viewer";
};
export type ShippingDetailsQuotesTableRow_viewer$key = {
  readonly " $data"?: ShippingDetailsQuotesTableRow_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShippingDetailsQuotesTableRow_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShippingDetailsQuotesTableRow_viewer",
  "selections": [
    {
      "alias": "showShippingDiscounts",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "subsidizedShippingPDP"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"subsidizedShippingPDP\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "8758077ffe027adfd986a5a358a8b058";

export default node;
